import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';
import assignmentSummarySaga from './saga';
import { AssignmentState } from './types';
import { RequestStatus } from 'constants/API';

export const initialState: AssignmentState = {
  getAssignmentDetailStatus: RequestStatus.IDLE,
  getAssignmentSummaryStatus: RequestStatus.IDLE,
  updateCommitEffortStatus: RequestStatus.IDLE,
  assignmentSummary: null,
  assignmentDetail: null,
};

const slice = createSlice({
  name: 'assignment_summary',
  initialState,
  reducers: {
    updateCommitEffortRequest: (state, action: PayloadAction<any>) => {
      if (action) state.updateCommitEffortStatus = RequestStatus.REQUESTING;
    },
    updateCommitEffortSuccess: (state, action: PayloadAction<any>) => {
      if (action) {
        state.updateCommitEffortStatus = RequestStatus.SUCCESS;
      }
    },
    updateCommitEffortFail: (state, action: PayloadAction<any>) => {
      state.updateCommitEffortStatus = RequestStatus.ERROR;
    },

    getAssignmentDetailRequest: (state, action: PayloadAction<any>) => {
      if (action) state.getAssignmentDetailStatus = RequestStatus.REQUESTING;
    },
    getAssignmentDetailSuccess: (state, action: PayloadAction<any>) => {
      if (action) {
        state.getAssignmentDetailStatus = RequestStatus.SUCCESS;
        state.assignmentDetail = action.payload;
      }
    },
    getAssignmentDetailFail: (state, action: PayloadAction<any>) => {
      state.getAssignmentDetailStatus = RequestStatus.ERROR;
    },

    getAssignmentSummaryRequest: (state, action: PayloadAction<any>) => {
      if (action) state.getAssignmentSummaryStatus = RequestStatus.REQUESTING;
    },
    getAssignmentSummarySuccess: (state, action: PayloadAction<any>) => {
      if (action) {
        state.getAssignmentSummaryStatus = RequestStatus.SUCCESS;
        state.assignmentSummary = action.payload;
      }
    },
    getAssignmentSummaryFail: (state, action: PayloadAction<any>) => {
      state.getAssignmentSummaryStatus = RequestStatus.ERROR;
    },

    resetAssignmentSummaryStatus: state => {
      state.getAssignmentSummaryStatus = RequestStatus.IDLE;
      state.getAssignmentDetailStatus = RequestStatus.IDLE;
      state.updateCommitEffortStatus = RequestStatus.IDLE;
      state.assignmentDetail = null;
    },
  },
});

export default slice.actions;

export const useAssignmentSummarySlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectSaga({ key: slice.name, saga: assignmentSummarySaga });
  return { actions: slice.actions };
};
